<template>
    <div class="w-file-upload">
        <el-upload :on-change="ImportData" drag :auto-upload="false" action="#" :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text"><b>客户管理：</b>将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-dialog :visible.sync="visible" class="w-el-dialog" fullscreen title="批量导入" append-to-body :before-close="Close" :close-on-click-modal="false" :close-on-press-escape="false">
            <uw-table :show-footer="false" :show-header="false">
                <template slot="data">
                    <vxe-table ref="xTable" :data="table" :loading="loading" :export-config="{}" height="100%">
                        <vxe-column width="60" type="seq" title="序号"></vxe-column>
                        <vxe-column min-width="150" field="name" title="客户名称" required></vxe-column>
                        <vxe-column min-width="150" field="work_phone" title="工作电话"></vxe-column>
                        <vxe-column min-width="150" field="user.name" title="所属员工"></vxe-column>
                        <vxe-column min-width="150" field="type" title="客户种类"></vxe-column>
                        <vxe-column min-width="150" field="country" title="区域或国家"></vxe-column>
                        <vxe-column min-width="150" field="country_province" title="省份"></vxe-column>
                        <vxe-column min-width="150" field="country_province_city" title="城市"></vxe-column>
                        <vxe-column min-width="150" field="address" title="详细地址"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_address" title="开票单位地址"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_name" title="开票单位名称"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_number" title="开票单位税号"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_phone" title="开票单位电话"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_bank_name" title="开票单位银行名称"></vxe-column>
                        <vxe-column min-width="150" field="invoice_unit_bank_number" title="开票单位银行卡号"></vxe-column>
                        <vxe-column title="错误提示" width="30%" align="center" fixed="right" v-if="tableError">
                            <template #default="{ row }">
                                <el-link type="danger">{{ row.error }}</el-link>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </template>
            </uw-table>
            <template slot="footer">
                <el-button size="mini" :loading="loading" @click="Close()">取 消</el-button>
                <el-button size="mini" type="primary"  @click="$refs.xTable.openExport()" >导出当前数据 / 导入模板</el-button>
                <el-button size="mini" type="success"  :loading="loading"  @click="SubmitForm()">开始导入</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
    data () {
        return {
            visible: false,
            loading: false,
            table: [],
            tableError: false
        }
    },
    methods: {
        ImportData(file) {
            this.visible = true
                        let dataBinary = new Promise((resolve) => {
                let reader = new FileReader();
                reader.readAsBinaryString(file.raw)
                reader.onload = (ev) => {
                                        let workBook = XLSX.read(ev.target.result, { type: "binary", cellDates: true });
                                        let firstWorkSheet = workBook.Sheets[workBook.SheetNames[0]]
                                        let data = XLSX.utils.sheet_to_json(firstWorkSheet);
                                        data.forEach(async (item) => {
                                                const { row: newRow } = this.$refs.xTable.insertAt({
                            'name': item['客户名称'],
                            'work_phone': item['工作电话'],
                            'user': { name: item['所属员工'] },
                            'user_id': await this.$http.post('/9api/hrm/employee/search-first', { name: item['所属员工'], hidden: ['wecom'] }).then((rps) => rps.data.id),
                            'type': item['客户种类'],
                            'type_id': await this.$http.post('/9api/customer-type/search-first', { search: { name: item['客户种类'] } }).then((rps) => rps.data.id),
                            'country': item['区域或国家'],
                            'country_province': item['省份'],
                            'country_province_city': item['城市'],
                            'address': item['详细地址'],
                            'invoice_unit_address': item['开票单位地址'],
                            'invoice_unit_name': item['开票单位名称'],
                            'invoice_unit_number': item['开票单位税号'],
                            'invoice_unit_phone': item['开票单位电话'],
                            'invoice_unit_bank_name': item['开票单位银行名称'],
                            'invoice_unit_bank_number': item['开票单位银行卡号'],
                            'error': false
                        }, -1)
                    })
                }
            })
        },
        SubmitForm() {
                        this.loading = true
                        let data = this.$refs.xTable.getTableData().tableData.filter(item => !item.parentField)
            data.forEach(async (element) => {
                                await this.$http.post('/9api/customer/create', element).then(rps => {
                                        this.loading = false
                                        if (rps.data.state == 'error') {
                        this.tableError = true
                        element.error = rps.data.body
                    }
                                        if (rps.data.state == 'success') {
                        this.$refs.xTable.remove(element)
                    }
                })
            });
        },
        Close() {
            this.table = []
            this.tableError = false
            this.visible = false
            this.loading = false
        }
    }
}
</script>